<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="false"></EForm>
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="true" :count="count"
      @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size"
      @handleSelect="handleSelectionChange" :needSelect="false">
      <div slot="checkStatus" slot-scope="scope">
        {{ scope.data.checkStatus == 0 ? '未审核' : scope.data.checkStatus == 1 ? '审核通过' : scope.data.checkStatus == 2 ?
          '审核未通过' :
        '-' }}
      </div>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="60%"
      @handleClick="saveData">
      <el-form label-position="right" label-width="150px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门名称" prop="groupName">
              <el-input v-model="form.groupName" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机" prop="mobile">
              <el-input v-model="form.mobile" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核状态" prop="checkStatus">
              <el-radio-group v-model="form.checkStatus">
                <el-radio :label="0">未审核</el-radio>
                <el-radio :label="1">审核通过</el-radio>
                <el-radio :label="2">审核未通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import vxRule from "@/assets/js/formValidate";
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      formColumns: [
        {
          title: '车牌号码',
          type: 'text',
          property: 'plateNo',
          placeHolder: '请输入',
          show: true,
        },
        {
          title: '入场通道',
          type: 'text',
          property: 'deviceName',
          placeHolder: '请输入',
          show: true,
        },
        {
          title: '计费车型',
          type: 'text',
          property: 'chargeRuleName',
          placeHolder: '请输入',
          show: true
        },
        {
          title: '滞留天数',
          type: 'select',
          property: 'days',//0未审核，1审核通过，2审核未通过
          show: true,
          options: [
            {
              label: '30天以上',
              value: 30,
            },
            {
              label: '20天以上',
              value: 20,
            },
            {
              label: '10天以上',
              value: 10,
            },
            {
              label: '5天以上',
              value: 5,
            },
            {
              label: '3天以上',
              value: 3,
            },
            {
              label: '2天以上',
              value: 2,
            },
            {
              label: '1天以上',
              value: 1,
            }
          ],
        }],
      tableTitle: [
        {
          label: '车牌号码',
          prop: 'plateNo',
        },
        {
          label: '计费车型',
          prop: 'ruleName',
        },
        {
          label: '入场通道',
          prop: 'deviceName',
        },
        {
          label: '入场时间',
          prop: 'enterTime',
        },
        {
          label: '滞留进长',
          prop: 'residenceTime'
        }
      ],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {},
      searchForm: {
        plateNo: '',
        deviceName: '',
        chargeRuleName: '',
        days: 30,
        current: 1,
        pageSize: 10
      },
      cascader: false,
      options: [],
      count: null,
      formRules: {
        title: [vxRule(true, '', "blur", "标题不能为空")],
      },
      labelPosition: 'right',
      labelWidth: '100px',
      selectRoutes: [],
      
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    //this.getOptions()
  },
  components: { ETable, EDialog, EButton, EForm },
  beforeMount() {

  },
  methods: {
    onSearch() {
      this.searchForm.current = 1
      this.getData()
    },
    changePage(page) {
      this.searchForm.current = page
      this.getData()
    },
    changeSize(size) {
      this.searchForm.size = size
      this.getData()
    },
    handleClose() {
      this.title = '添加信息'
      this.dialogVisible = false
      this.form = {}
      //this.$refs.form.resetFields()
    },
    handleSelectionChange(data) {
      if (data.length > 0) {
        data.forEach((item) => {
          this.selectRoutes.push(item.id);
        });
      }
    },
    deleteMore() {
      this.deleteInfo(this.selectRoutes.toString());
    },
    deleteInfo(ids) {
      this.$messageBox
        .confirm(`确定删除该信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          this.removeRoute(ids);
        })
        .catch((res) => { });
    },
    async getData() {
      let res = await Http.stopcarlist(this.searchForm)
      if (res.code == 200) {
        this.tableData = res.data.data.rows
        this.count = res.data.data.total
      }

    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    async addBtn() {
      let res = await Http.serviceusercheckstatus(this.form)
      console.log(JSON.stringify(res))
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.getData()
      }else{
        this.$message.success(res.msg)
        this.getData()
      }
    },
    editDialog(data) {
      this.title = '编辑信息'
      this.form = data
      //this.form = {
      //  name: data.name
      //}
      this.dialogVisible = true
    },
    async removeRoute(ids) {
      let res = await Http.noticeRemoveRoute({ ids });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
